import "core-js/modules/web.dom-collections.iterator.js";
import T from 'prop-types';
import { cloneElement, useReducer, useRef, useState } from 'react';
import styled from 'styled-components';
import { useId } from '../../hooks/useId';
import { placements, usePopper } from '../../hooks/usePopper';
import { black72, blackAlpha16, white } from '../../styles/colors';
import { layout } from '../../styles/system';
import * as typography from '../../styles/typography';
import { unit } from '../../styles/unit';
import { Portal } from '../Portal/Portal';
import { TooltipIndicator } from './TooltipIndicator';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TooltipMessage = /*#__PURE__*/styled.div.attrs(({
  role,
  maxWidth
}) => ({
  role: role === undefined ? 'tooltip' : role,
  maxWidth: maxWidth || 50
})).withConfig({
  displayName: "TooltipMessage",
  componentId: "mkgb5h-0"
})(["", " ", ";background-color:", ";color:", ";padding:", ";box-shadow:0px 4px 8px ", ";border-radius:4px;"], typography.caption, layout.maxWidth, black72, white, unit(2), blackAlpha16);
const FOCUS = 'FOCUS';
const BLUR = 'BLUR';
const MOUSE_ENTER = 'MOUSE_ENTER';
const MOUSE_LEAVE = 'MOUSE_LEAVE';

function reducer(state, action) {
  switch (action.type) {
    case FOCUS:
      return {
        visible: true,
        isFocused: true
      };

    case BLUR:
      return {
        visible: false,
        isFocused: false
      };

    case MOUSE_ENTER:
      return Object.assign({}, state, {
        visible: true
      });

    case MOUSE_LEAVE:
      if (state.isFocused) {
        return state;
      }

      return {
        visible: false,
        isFocused: false
      };

    default:
      throw new Error(`The action "${action.type}" does not exist"`);
  }
}

function Tooltip({
  id: propId,
  placement = 'top',
  children,
  title,
  visible: visibleProp
}) {
  const uid = useId('tooltip');
  const id = propId || uid;
  const indicatorRef = useRef(null);
  const [popperElement, setPopperElement] = useState(null);
  const {
    styles
  } = usePopper(indicatorRef, popperElement, {
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 4]
      }
    }],
    placement
  });
  const [state, dispatch] = useReducer(reducer, {
    visible: false,
    isFocused: false
  });
  const visible = visibleProp !== null && visibleProp !== void 0 ? visibleProp : state.visible;

  const handleFocus = () => {
    dispatch({
      type: FOCUS
    });
  };

  const handleBlur = () => {
    dispatch({
      type: BLUR
    });
  };

  const handleMouseEnter = () => {
    dispatch({
      type: MOUSE_ENTER
    });
  };

  const handleMouseLeave = () => {
    dispatch({
      type: MOUSE_LEAVE
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/cloneElement(children, {
      ref: indicatorRef,
      'aria-describedby': visible ? id : null,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      onFocus: handleFocus,
      onBlur: handleBlur
    }), visible && /*#__PURE__*/_jsx(Portal, {
      children: /*#__PURE__*/_jsx(TooltipMessage, {
        ref: setPopperElement,
        id: id,
        style: styles.popper,
        children: title
      })
    })]
  });
}

Tooltip.propTypes = {
  children: T.node.isRequired,
  title: T.node.isRequired,
  id: T.string,
  placement: T.oneOf(placements),
  visible: T.bool
};
export { Tooltip, TooltipMessage, TooltipIndicator };